export default __webpack_public_path__ + "static/media/2.fd7b26ca.jpg";